import React, { useState, useRef, useEffect, useMemo } from "react";
import { useTable, usePagination, useRowSelect } from "react-table";
import * as XLSX from "xlsx";
import Cards from "../Cards";
import double_before from "../../../../assets/vw/svg/double-before.svg";
import before from "../../../../assets/vw/svg/before.svg";
import after from "../../../../assets/vw/svg/after.svg";
import double_after from "../../../../assets/vw/svg/double-after.svg";
import DropDown from "../../../../components/Dropdown";
import SEARCH from "../../../../assets/vw/svg/search.svg";
import activo_icono from "../../../../assets/vw/svg/point-verde.svg";
import inactivo_icono from "../../../../assets/vw/svg/point-rojo.svg";
import editar_icon from "../../../../assets/vw/svg/editar_blanco.svg";
import archivar_blanco from "../../../../assets/vw/svg/archivar_blanco.svg";
import menu_opc from "../../../../assets/vw/svg/menu-opciones.svg";
import success_icono from "../../../../assets/vw/svg/check-exito.svg";
import error_icono from "../../../../assets/vw/svg/check-error.svg";
import cerrar from "../../../../assets/vw/svg/cerrar.svg";
import Loading from "../../../../components/Loading";
import DropdownSearch from "../../../../components/DropdownSearch";
import InputText from "../../../../components/InputText";
import StaticTextField from "../../../../components/StaticTextField";
import icono_vw from "../../../../assets/vw/svg/vw.svg";
import icono_seat from "../../../../assets/vw/svg/seat.svg";
import icono_cupra from "../../../../assets/vw/svg/cupra.svg";
import icono_audi from "../../../../assets/vw/svg/audi.svg";
import null_icono from "../../../../assets/vw/svg/null.svg";

import TextArea from "../../../../components/TextArea";

const concesionariaInitial = {
  razon: "", // Nombre
  nomComercial: "", // Nombre comercial
  numCON:"",
  idCON: 0,
  id_Marc:"", // Marca
  estadoActivo: 1,
  correoContacto: "", // Correo
  dwa_Contacto:"", // Correo DWA
  tel_contacto:"", // Télefono
  direct_Con:"", // Dirección
  cp:"", // Código Postal
  entidad_Con:"", // Estado
  ciudad_Con:"", //Ciudad
  ubicacionGeof:"", // Ubicación
  tyc_Con:"", // Términos y condiciones
};


const IndeterminateCheckbox = React.forwardRef(
  ({ indeterminate, ...rest }, ref) => {
    const defaultRef = React.useRef();
    const resolvedRef = ref || defaultRef;

    React.useEffect(() => {
      resolvedRef.current.indeterminate = indeterminate;
    }, [resolvedRef, indeterminate]);

    return (
      <input
        type="checkbox"
        className="checkbox-round"
        ref={resolvedRef}
        {...rest}
      />
    );
  }
);



function Table({ columns, data, servicio, handleChange }) {

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    selectedFlatRows,
    toggleAllRowsSelected,
    setPageSize,
    state: { pageIndex },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageSize: 15 },
    },
    usePagination,
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push((columns) => [
        {
          id: "selection",
          Header: ({ getToggleAllPageRowsSelectedProps }) => (
            <div>
              <IndeterminateCheckbox {...getToggleAllPageRowsSelectedProps()} />
            </div>
          ),
          Cell: ({ row }) => (
            <div>
              <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} />
            </div>
          ),
        },
        ...columns,
      ]);
    }
  );
  
  const visibleColumns = headerGroups[0]?.headers;

  const [modal, setModal] = useState(false);
  const [cargando, setCargando] = useState(false);

  const [concesionaria, setConcesionaria] = useState(concesionariaInitial);
  const [limit, setLimit] = useState(10);
  const limitMostrar = useMemo(() => ["Mostrar 15", "Mostrar 30", "Mostrar 50", "Todo"], []);
  const [dropdownLimit, setDropdownLimit] = useState(limitMostrar[0])
  const [searchInput, setSearchInput] = useState("");
  const [row, setRow] = useState("");
  const [mostrarModal, setMostrarModal] = useState(false);
  const [mensajeArchivar, setMensajeArchivar] = useState(
    "¿Seguro que quieres archivar esta concesionaria?"
  );
  const [successArchivar, setSuccessArchivar] = useState(false);
  const [errorArchivar, setErrorArchivar] = useState(false);
  const marcas = ["VW", "VW Comercial", "Seat", "Audi", "Cupra"];
  const estadoCat = ["Activo", "Inactivo"];
  const [actualizar, setActualizar] = useState(false);
  const [showGrid, setShowGrid] = useState(false);
  const [selectGrid, setSelectGrid] = useState([]);
  const [edita, setEdita] = useState(false);
  const [selectedDealer, setSelectedDealer] = useState();

  const [filasRevisadas, setFilasRevisadas] = useState([]);
  const [numModificaciones, setNumModificaciones] = useState(0)

  const api = process.env.REACT_APP_URL_DTO_BACK + "concesionaria";


  const optionLimit = (textoLimit) => {
    switch (textoLimit) {
      case "Mostrar 15":
        return 15;
      case "Mostrar 30":
        return 30;
      case "Mostrar 50":
        return 50;
      case "Todo":
        return data.length;
      default:
        return data.length;
    }
  };

  const [dataArchivo, setDataArchivo] = useState([]);
  const fileInputRef = useRef(null);

  const cargarArchivo = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click(); // Simula clic en el input oculto
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files?.[0];

    if (file) {

      const NOMBRE_HOJA = 'Proveedor';

      const reader = new FileReader();
      reader.onload = (evt) => {
        const data = new Uint8Array(evt.target.result);
        const workbook = XLSX.read(data, { type: 'array' });

        const normalizeHeader = (header) => {
          return header.normalize("NFD").replace(/[̀-ͯ]/g, "").toUpperCase().trim();
        };

        /// Verifica si la hoja existe en el archivo
        if (!workbook.SheetNames.includes(NOMBRE_HOJA)) {
          alert(`La hoja "${NOMBRE_HOJA}" no fue encontrada en el archivo.`);
          return;
        }

        // Carga solo la hoja específica
        const sheet = workbook.Sheets[NOMBRE_HOJA];
        const rawData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

        if (rawData.length < 2) {
          alert("El archivo no tiene suficientes datos.");
          return;
        }

        const valueMap = {
          "Refacciones MAN": "VWC",
          "VWVC": "VWC",
          "TALLER VWVC": "VWC",
          "VW/SEAT": "VW",
          " TALLER VW": "VW",
          "TALLER SEAT": "SEAT",
          "TALLER AUDI": "AUDI"
        };
        
        const invalidBrands = ["Multimarca", "BENTLEY", "PORSCHE", "INTERNO"];
        
        const headers = rawData[0].map(normalizeHeader);

        const formattedData = rawData.slice(1).map(row => {
          const obj = {};
          let isValid = true;
        
          headers.forEach((header, index) => {
            if (!header) return;
        
            const rawValue = row[index];
            let mappedValue = valueMap[rawValue] || rawValue || "";
            
            if (header === "CONMUTADOR") {
              // Verificar si el valor ya es válido (entre 7 y 10 dígitos, solo números)
              const isValidNumber = /^[0-9]{7,10}$/.test(mappedValue);
              
              if (!isValidNumber) {
                // Si no es válido, limpiar el valor
                const cleanedNumbers = mappedValue
                  .replace(/\s+/g, "") // Eliminar todos los espacios
                  .replace(/[-.]/g, "") // Eliminar guiones y puntos
                  .replace(/\(.*?\)/g, "")
                  .split(/(?<=[0-9])(?=[a-zA-Z])|(?<=[a-zA-Z])(?=[0-9])|[/|]/g) // Dividir por letras, "/", o "|"
                  .filter((part) => /^[0-9]{7,10}$/.test(part)); 
            
                // Tomar solo el primer número válido
                mappedValue = cleanedNumbers.length > 0 ? cleanedNumbers[0] : "";
              }
            }
            
            obj[header] = mappedValue;
        
            // Validación de campos críticos
            if (
              (header === "CON" && !mappedValue) ||
              (header === "MARCA" && invalidBrands.includes(mappedValue))
            ) {
              isValid = false;
            }
          });
        
          return isValid ? obj : null;
        }).filter(Boolean);

        // Construir el array de concesionarias
        const concesionarias = formattedData.map(item => ({
          razon: item["RAZON SOCIAL"] ? item["RAZON SOCIAL"].toUpperCase().trim() : "",
          nomComercial: item["NOMBRE COMERCIAL"] ? item["NOMBRE COMERCIAL"].toUpperCase().trim() : "",
          // Se asigna el correo de la concesionaria como string
          numCON: String(item["CON"] || "").trim(),
          estadoActivo: 1,
          correoContacto: item["EMAIL"] || item["CORREO"] || `${item["CON"]}rcvwm@vw-concesionarios.com.mx`,
          tel_contacto: `${item["LADA"] || ""}${item["CONMUTADOR"] || ""}`.trim(),
          ubicacionGeof: (item["GEOLOCALIZACION LATITUD"] && item["GEOLOCALIZACION LONGITUD"])
                        ? `${item["GEOLOCALIZACION LATITUD"]}, ${item["GEOLOCALIZACION LONGITUD"]}`.trim()
                        : "",
          id_Marc: getMarcaId(item["MARCA"] || "0"),
          direct_Con: (item["DIRECCION FISICA"] ?  `${item["DIRECCION FISICA"].toUpperCase().trim()}` : "") + (item["COLONIA"] ? `, ${item["COLONIA"].toUpperCase().trim()}` : ""),
          dwa_Contacto: item["CORREO DWA"] || "",
          cp: String(item["CP"] || item["CODIGO POSTAL"] || "").trim(),
          entidad_Con: item["ESTADO"] ? item["ESTADO"].toUpperCase().trim() : "",
          ciudad_Con: item["CIUDAD"] ? item["CIUDAD"].toUpperCase().trim() : ""
        }));
        setDataArchivo(concesionarias);
      };
      reader.readAsArrayBuffer(file);
    }
    event.target.value = '';
  };

  function getMarcaId (nombre) {
    switch (nombre.toUpperCase().trim()) {
      case "VW":
        return 1;
      case "VW COMERCIAL":
      case "VWC":
        return 2;
      case "SEAT":
        return 3;
      case "AUDI":
        return 4;
      case "CUPRA":
        return 5;
      default:
        return 0; // Marca desconocida
    }
  }
  
  const [filasModificadas, setFilasModificadas] = useState([]);
  const [isPaginationDisabled, setPaginationDisabled] = useState(false)

  useEffect(() => {
    
    if (!dataArchivo || dataArchivo.length === 0 || !data || data.length === 0) return;
    const modificadas = [];
    // Se verifica si las concesionarias guardadas existen en el archivo,
    // se guardan en un arreglo de modificaciones indicando qué tipo de modificacion es, en este caso "baja"
    data.forEach((concesionaria) => {
      const concesionariaExistente = dataArchivo.find(
        (concesionariaArchivo) => concesionariaArchivo.numCON === concesionaria.numCON
      );
      // Cambio = 1 es baja
      if (!concesionariaExistente) {
        const cambios = {}
        cambios.idCON = concesionaria.idCON;
        cambios.cambio = 1;
        cambios.numCON = concesionaria.numCON;
        modificadas.push(cambios);
      }
    })

    let i = 1;
    
    dataArchivo.forEach((concesionariaArchivo) => {
      // Verifica que la concesionaria del archivo exista en la base de datos
      // Si no existe se agrega como una nueva al arreglo de modificaciones
      const concesionariaExistente = data.find(
        (concesionaria) => concesionaria.numCON === concesionariaArchivo.numCON
      );

      if (concesionariaExistente) {
        //Guarda los cambios unicamente y el numero de concesionaria para ubicarlo en la tabla
        const cambios = {};
        Object.keys(concesionariaArchivo).forEach((key) => {
          if (concesionariaArchivo[key] !== concesionariaExistente[key]) {
            cambios[key] = concesionariaArchivo[key];
          }
        });
        // Cambio = 2 es modificacion
        if (Object.keys(cambios).length > 0) {
          cambios.numCON = concesionariaArchivo.numCON;
          cambios.cambio = 2
          modificadas.push(cambios);
        }
      } else {
        // Si no existe, se agrega como nueva
        // Cambio = 3 es alta
        const cambios = {};
        cambios.cambio = 3;
        concesionariaArchivo.idCON = data.length + i++;
        concesionariaArchivo.cambios = cambios;
        modificadas.push(concesionariaArchivo);
      }
    })

    if(modificadas.length !==0 ){
      setPaginationDisabled(true);
      setDropdownLimit(limitMostrar[3]);
      setLimit(data.length);
      setPageSize(Number(data.length));
      onChangeGrid(false)
    }

    setFilasModificadas(modificadas)
    setNumModificaciones(modificadas.length)

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataArchivo, data]);

  const filasCambios = useMemo(() => {
    
    if (filasModificadas.length === 0) return [];
    // Filtrar filas que ya existen en `page` y están en `filasModificadas`
    const filasExistentes = data
      .filter((row) => {
        return filasModificadas.some(
          (modificada) => modificada.numCON === row.numCON
        );
      })
      .map((row) => {
        // Añadir el campo `cambios` a las filas existentes
        const cambios = filasModificadas.find(
          (modificada) => modificada.numCON === row.numCON
        );

        return {
          ...row,
          cambios: cambios || {}, // Incluye los cambios encontrados
        };
      })
      .sort((a, b) => (b.cambios.cambio || 0) - (a.cambios.cambio || 0)); // Ordenar por cambios.cambio de mayor a menor
  
    // Añadir filas nuevas que no están en `page`
    const filasNuevas = filasModificadas.filter(
      (modificada) =>
        !data.some((row) => row.numCON === modificada.numCON)
    );
    // Combinar filas existentes y nuevas
    return [...filasNuevas, ...filasExistentes];
  }, [filasModificadas, data]);

  const filas = useMemo(() => {
    if (filasModificadas.length === 0) return page;
  
    return page.filter((row) => {
      // Excluir las filas que están en filasModificadas
      return !filasModificadas.some(
        (modificada) => modificada.numCON === row.original.numCON
      );
    });
  }, [page, filasModificadas]);

  const obtenerClaseFila = (cambio) => {

    switch (cambio) {
      case 1:
        return "text-danger";
      case 2:
        return "text-warning";
      case 3:
        return "text-success";
      default:
        return "";
    }
  };

  function editConcesionaria(e) {
    setActualizar(true);
    setModal(true);
    setConcesionaria(e);
    setEdita(true)
  }

  function addConcesionaria(e) {
    setActualizar(false);
    toggleAllRowsSelected(false);
    setModal(true);
    console.log("e", e);
    setConcesionaria(e !== null ? e : concesionariaInitial);
    setEdita(false)
  }

  async function sendConcesionariaData() {
    const body = { ...concesionaria };
    delete body.idCON;
    delete body.regFecha_Con;
    delete body.cambios;
    assignEmptyStringToNullProperties(body);

    // Convertir los campos a mayúsculas
    body.razon = body.razon.toUpperCase();
    body.nomComercial = body.nomComercial.toUpperCase();
    body.ciudad_Con = body.ciudad_Con.toUpperCase();
    body.entidad_Con = body.entidad_Con.toUpperCase();
    body.direct_Con = body.direct_Con.toUpperCase();

    if (!validateEmail(body.correoContacto)) {
      alert("El correo no es válido.");
      return;
    }

    const method = actualizar ? "PUT" : "POST";
    const numConcesionaria = body.numCON;

    const params =
      method === "PUT"
        ? new URLSearchParams({
          numCON: numConcesionaria,
        })
        : "";

    setCargando(true);
    setModal(false);
    try {
      const res = await fetch(api + "?" + params, {
        method,
        headers: {
          Authorization: "Bearer " + servicio.getToken(),
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });
      
      const responseBody = await res.json();
      setCargando(false);
      setMostrarModal(true);

      if (res.ok) {
        setMensajeArchivar("Los cambios fueron guardados.");
        setSuccessArchivar(true);
        setErrorArchivar(false);
        
        if (concesionaria.cambios && !filasRevisadas.includes(concesionaria.numCON)) {
          setFilasRevisadas((prev) => [...prev, concesionaria.numCON]); // Agregar a filas revisadas
          setNumModificaciones((prev) => prev - 1); // Reducir el conteo
          updateCheckedStatus(concesionaria.numCON, true); // Marcar como revisada
        }

      } else {
        setMensajeArchivar("Hubo un error al guardar los cambios. " + responseBody.mensaje);
        setSuccessArchivar(false);
        setErrorArchivar(true);
      }
    } catch (error) {
      setCargando(false);
      setMensajeArchivar("Hubo un error al guardar los cambios. " + error.message);
      setErrorArchivar(true);
      setMostrarModal(true);
    }
  }

  async function activaDesactiva() {
    setCargando(true);
    setMostrarModal(false);
    let arrayConsencionaria = [];
    if (row !== "") {
      arrayConsencionaria.push(row);
    } else if (selectedFlatRows.length > 0) {
      arrayConsencionaria = selectedFlatRows.map((row) => row.original);
    } else if (selectGrid.length > 0) {
      arrayConsencionaria = selectGrid;
    }

    for (let concesionaria of arrayConsencionaria) {
      fetch(
        api +
        "?" +
        new URLSearchParams({
          numCON: concesionaria.numCON,
        }),
        {
          method: "PUT",
          headers: {
            Authorization: "Bearer " + servicio.getToken(),
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            estadoActivo: 0,
          }),
        }
      )
        .then(async (res) => {
          let responseBody = await res.json();
          if (!res.ok) {
            throw new Error(responseBody.mensaje);
          }
          setRow("");
          setCargando(false);
          setMensajeArchivar("Los cambios fueron guardados.");
          setSuccessArchivar(true);
          setMostrarModal(true);
        })
        .catch((errorP) => {
          setRow("");
          setCargando(false);
          setMensajeArchivar("Hubo un error al guardar los cambios.");
          setErrorArchivar(true);
          setMostrarModal(true);
        });
    }
  }

  function searchText(e) {
    setSearchInput(e.target.value);
    handleChange(e);
  }

  function handleArchivar(e) {
    selectedFlatRows.length < 1 && selectGrid.length < 1
      ? setRow(e.row.original)
      : setRow("");
    setMostrarModal(true);
  }

  function clearModalArchivar() {
    // eslint-disable-next-line no-restricted-globals
    if(filasModificadas.length === 0) location.reload();
    
    setRow("");
    setMostrarModal(false);
    setMensajeArchivar("¿Seguro que quieres archivar esta concesionaria?");
    setSuccessArchivar(false);
    setErrorArchivar(false);
  }

  const buildPopUp = () => {
    return (
      <div
        className={`modal modal_vw modal_popup_vw fade ${mostrarModal ? "show" : ""}`}
        id="archivar"
        data-keyboard="false"
        data-backdrop="static"
        tabIndex="-1"
        aria-labelledby="archivarLabel"
        style={mostrarModal ? { display: "block" } : {}}
        aria-modal="true"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered modal_popup_content">
          <div className="modal-content modal_content-vw">
            <div className="modal-header modal_header-vw">
              <div className="d-flex justify-content-end">
                <button
                  className="button_icon-vw"
                  type="button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={clearModalArchivar}
                >
                  <img src={cerrar} alt="cerrar"></img>
                </button>
              </div>
            </div>
            <div className={`modal-body p-3 p-sm-5 p-lg-5`}>
              {buildContent()}
              {successArchivar || errorArchivar ? "" : buildButtons()}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const buildContent = () => {
    return (
      <>
        {successArchivar ? (
          <div className="mt-0 mt-lg-2 px-2 mensaje_confirmacion mb-0 mb-sm-5">
            <div className="d-flex justify-content-center">
              <img
                src={success_icono}
                className="icono-mensaje"
                alt="exito"
              ></img>
            </div>
            <label className="popup_title popup_title--status d-flex justify-content-center">
              {mensajeArchivar}
            </label>
          </div>
        ) : errorArchivar ? (
          <div className="mt-0 mt-lg-2 px-2 mensaje_confirmacion mb-0 mb-sm-5">
            <div className="d-flex justify-content-center">
              <img
                src={error_icono}
                className="icono-mensaje"
                alt="error"
              ></img>
            </div>
            <label className="popup_title popup_title--status d-flex justify-content-center">
              {mensajeArchivar}
            </label>
          </div>
        ) : (
          <div className="mt-0 mt-lg-2 px-2 mensaje_confirmacion mb-0 mb-sm-5">
            <label className="popup_title d-flex justify-content-center">
              {mensajeArchivar}
            </label>
          </div>
        )}
      </>
    );
  };

  const buildButtons = () => {
    return (
      <div className="d-flex justify-content-center gap-3 mt-3 mt-sm-4 mt-lg-5 mb-3 mb-lg-5">
        <button
          type="button"
          className="button_vw button_vw--secondary"
          data-bs-dismiss="modal"
          onClick={clearModalArchivar}
        >
          Cancelar
        </button>
        <button
          type="button"
          className="button_vw button_vw--primary"
          data-bs-dismiss="modal"
          onClick={()=>{
            if(concesionaria.cambios?.cambio === 3){
              setModal(false);
              setMostrarModal(false);
              setFilasRevisadas((prev) => [...prev, concesionaria.numCON]); // Agregar a filas revisadas
              setNumModificaciones((prev) => prev - 1); // Reducir el conteo
              updateCheckedStatus(concesionaria.numCON, true);
              clearModalArchivar()
            }else{
              activaDesactiva()
            }
          }}
        >
          {concesionaria.cambios?.cambio === 3 ? "Aceptar" : "Archivar"}
        </button>
      </div>
    );
  };

  const getDireccionesCP = (cp) => {
    fetch(
      process.env.REACT_APP_URL_DTO_BACK + "/codigopostal?cp=" + cp,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
      .then(async (res) => {
        let response = await res.json();
        if (!res.ok) {
          throw new Error(response.mensaje);
        }
        return response;
      })
      .then((data) => {
        if (Array.isArray(data.mensaje) && data.mensaje.length > 0) {
          let ciudad =
            data.mensaje[0].ciudad !== ""
              ? data.mensaje[0].ciudad
              : data.mensaje[0].municipio;
          setConcesionaria({
            ...concesionaria,
            entidad_Con: data.mensaje[0].estado,
            ciudad_Con: ciudad,
            cp: cp,
          });
        } else {
          setConcesionaria({
            ...concesionaria,
            ciudad_Con: "",
            entidad_Con: "",
            cp: cp,
          });
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const onChangeCP = (event) => {
    if (event.target.value.length < 6) {
    if (event.target.value.length === 5) {
      getDireccionesCP(event.target.value);
    } else {
      setConcesionaria({
        ...concesionaria,
        entidad_Con: "",
        ciudad_Con: "",
        cp: event.target.value,
      });
    
    }
  }
  
  };


  
  const onChangeNumConcensinaria = (event) => {
    setConcesionaria({
      ...concesionaria,
      numCON: event.target.value,
    });
  };

  const onChangeTelefono = (event) => {
    let value = event.target.value;
    setConcesionaria({
      ...concesionaria,
      tel_contacto: value,
    });
  };

  const generateFormattedChangesMessage = (cambios) => {
    if (!cambios || Object.keys(cambios).length === 0) {
      return "No se encontraron cambios.";
    }
  
    // Mapeo de nombres de campos a nombres legibles
    const fieldNames = {
      razon: "Nombre",
      nomComercial: "Nombre comercial",
      id_Marc: "Marca",
      correoContacto: "Correo",
      dwa_Contacto: "Correo DWA",
      tel_contacto: "Teléfono",
      direct_Con: "Dirección",
      cp: "Código Postal",
      entidad_Con: "Estado",
      ciudad_Con: "Ciudad",
      ubicacionGeof: "Ubicación",
      tyc_Con: "Términos y condiciones",
    };
  
    // Filtrar y formatear los cambios
    const cambiosString = Object.entries(cambios)
      .filter(([key]) => !["cambio", "numCON", "estadoActivo", "idCON","cambios", "checked"].includes(key)) // Excluir campos no deseados
      .map(([key, value]) => {
        const fieldName = fieldNames[key] || key; // Obtener el nombre legible o usar la clave como fallback
        const formattedValue = key === "id_Marc" ? marcaCatTable(value) : value; // Aplicar marcaCatTable si es `id_Marc`
        return `${fieldName}: ${formattedValue}`;
      })
      .join("\n"); // Unir con saltos de línea
  
    return cambiosString;
  };

  const buildPopUpRegistro = () => {
    
    let editar = null
    let mensaje = ""

    if(concesionaria.cambios){
      editar = concesionaria.cambios.cambio;
      if(concesionaria.cambios.cambio === 1){
        mensaje = "La concesionaria no se encontró en el archivo, se recomienda desactivarla"
      }else if(concesionaria.cambios.cambio === 2){
        mensaje = generateFormattedChangesMessage(concesionaria.cambios);
      }
    }

    return (
      modal && (<div
        className={`modal modal_vw fade ${modal ? "show" : ""}`}
        id="modal"
        data-keyboard="false"
        data-backdrop="static"
        tabIndex="-1"
        aria-labelledby="desarchivarLabel"
        style={modal ? { display: "block" } : {}}
        aria-modal="true"
        role="dialog"
      >
        <div
          className="modal-dialog modal-dialog-centered modal_lg_vw "
          role="document"
        >
          <div className="modal-content modal_content-vw p-0 p-lg-2">
            <div className="modal-header modal_header-vw py-lg-0">
              <div className="d-flex justify-content-end">
                <button
                  className="button_icon-vw"
                  type="button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    setModal(false);
                  }}
                >
                  <img src={cerrar} alt="cerrar"></img>
                </button>
              </div>
            </div>
            <form className={"position-relative"} onSubmit={sendConcesionariaData}>
              <div  className={`modal-body mx-3 mx-sm-4 mx-lg-5 p-0 mb-2 mb-sm-4 mb-lg-0 position-static`}>
                <div className="modal-title-container d-flex justify-content-start titulo pb-2">
                  <span className={"modal-title-principal-text"}>{edita ? "Editar concesionaria" : "Nueva concesionaria"}</span>
                  {
                    edita && (
                      <button
                        type="button"
                        className={"button_vw button_vw--archivo modal-btn-archivar-top"}
                        onClick={() => {
                          if (selectedDealer) {
                            setConcesionaria(concesionariaInitial)
                            handleArchivar(selectedDealer);
                          }
                        }}
                      >
                        <div className={"archivar-icon"}></div>
                        <span className={"ml-2"}>Archivar</span>
                      </button>
                    )
                  }
                </div>
                <div className=" border_vw"></div>
                {(editar !== 3 && concesionaria.cambios) ? (
                  <>
                    <div className="row p-0 mx-0 mt-2"  >
                      <div style={{height:"300px"}} className="col-12 col-sm-8 overflow-auto row justify-content-center py-4">
                        <div className="col-12 ps-0 pr-0 mt-2 mt-sm-0">
                          <InputText
                            inputLabel={"Nombre"}
                            id={"razon"}
                            inputField={concesionaria.razon}
                            changingInput={(event) => {
                              setConcesionaria({
                                ...concesionaria,
                                razon: event.target.value,
                              });
                            }}
                            required={true}
                          />

                        </div>

                        <div className="col-12 ps-0 pr-0 mt-2 mt-sm-4">
                          <InputText
                            inputLabel={"Nombre comercial"}
                            id={"nomComercial"}
                            inputField={concesionaria.nomComercial}
                            changingInput={(event) => {
                              setConcesionaria({
                                ...concesionaria,
                                nomComercial: event.target.value,
                              });
                            }}
                            required={true}
                          />

                        </div>

                        <div className="d-flex flex-column flex-lg-row p-0">
                          <div className="w-100 w-lg-50 pe-lg-2 mt-4">
                            <InputText
                              inputLabel={"Número concesionaria"}
                              inputField={concesionaria.numCON}
                              changingInput={(event) => onChangeNumConcensinaria(event)}
                              validationFunction= {(event) => event.target.value.length < 5}
                              required={true}
                              disabled={concesionaria.idCON}
                              id={"numCON"}
                            />

                          </div>

                          <div className="w-100 w-lg-50 ps-lg-2 mt-4">
                            <DropdownSearch
                              menu={marcas.map((marca) => (
                                {
                                  nombre: marca,
                                }
                              ))}
                              title={"Marca"}
                              defaultValue={marcaCatTable(concesionaria.id_Marc)}
                              handleOptionSelected={(e) => {
                                const id_Marc = idMarcaCat(e.props.value);
                                setConcesionaria({
                                  ...concesionaria,
                                  id_Marc: parseInt(id_Marc),
                                })
                              }}
                              fieldID={'nombre'}
                              fieldToShow={'nombre'}
                            />
                          </div>

                        </div>

                        <div className="col-12 ps-0 p-0 mt-4">
                          <DropdownSearch
                            menu={estadoCat.map((ele, index) => {
                              return {
                                nombre: ele
                              }
                            })}
                            title={"Estado"}
                            defaultValue={concesionaria.estadoActivo ? "Activo" : "Inactivo"}
                            handleOptionSelected={(e) => {
                              let status = e.props.value === "Activo" ? 1 : 0;
                              setConcesionaria({
                                ...concesionaria,
                                estadoActivo: status,
                              });
                            }}
                            fieldID={'nombre'}
                            fieldToShow={'nombre'}
                          />
                        </div>

                        <div className="col-12 ps-0 pr-0 mt-5">
                          <InputText
                            inputLabel={"Dirección"}
                            inputField={concesionaria.direct_Con}
                            changingInput={(event) => {
                              setConcesionaria({
                                ...concesionaria,
                                direct_Con: event.target.value,
                              });
                            }}
                            required={true}
                            id={"direct_Con"}
                          />

                        </div>

                        <div className="col-12 ps-0 p-0 mt-4">
                          <InputText
                            inputLabel={"Código postal"}
                            inputField={concesionaria.cp}
                            changingInput={(event) => onChangeCP(event)}
                            validationFunction={(event) => event.target.value.length < 6}
                            required={true}
                            id={"cp"}
                          />

                        </div>

                        <div className="d-flex flex-column flex-lg-row p-0">
                          <div className="w-100 w-lg-50 pe-lg-2 mt-4">
                            <StaticTextField 
                              value={concesionaria.entidad_Con}
                              inputLabel={"Estado"}
                            />
                          </div>

                          <div className="w-100 w-lg-50 ps-lg-2 mt-4">
                            <StaticTextField 
                              value={concesionaria.ciudad_Con}
                              inputLabel={"Ciudad"}
                            />
                          </div>
                        </div>

                        <div className="col-12 ps-0 p-0 mt-4">
                          <InputText
                            inputLabel={"Ubicación"}
                            inputField={concesionaria.ubicacionGeof}
                            changingInput={(event) => {
                              setConcesionaria({
                                ...concesionaria,
                                ubicacionGeof: event.target.value,
                              });
                            }}
                            required={true}
                            id={"ubicacionGeof"}
                          />

                        </div>

                        <div className="col-12 ps-0 pr-0 mt-4">
                          <InputText
                            inputLabel={"Correo"}
                            inputField={concesionaria.correoContacto}
                            changingInput={(event) => {
                              setConcesionaria({
                                ...concesionaria,
                                correoContacto: event.target.value,
                              });
                            }}
                            required={true}
                            type="email"
                            id={"correoContacto"}
                          />

                        </div>

                        <div className="col-12 ps-0 pr-0 mt-4">
                          <InputText
                            inputLabel={"Teléfono"}
                            inputField={concesionaria.tel_contacto}
                            changingInput={(event) => onChangeTelefono(event)}
                            validationFunction={(event) => {
                              if (event.target.value.length < 11) {
                                let value = event.target.value;
                                const pattern = new RegExp("^[0-9]*$");
                                let isValidKey = pattern.test(value);
                                return isValidKey;
                              }
                              return false;
                            }}
                            required={true}
                            id={"tel_contacto"}
                          />
                        </div>

                        <div className="col-12 ps-0 pr-0 mt-4">
                          <InputText
                            inputLabel={"Correo DWA"}
                            inputField={concesionaria.dwa_Contacto}
                            changingInput={(event) => {
                              setConcesionaria({
                                ...concesionaria,
                                dwa_Contacto: event.target.value,
                              });
                            }}
                            id={"dwa_Contacto"}
                            type="email"
                          />

                        </div>

                        <div className="col-12 ps-0 pr-0 mt-4">
                          <InputText
                            inputLabel={"Términos y condiciones"}
                            inputField={concesionaria.tyc_Con}
                            changingInput={(event) => {
                              setConcesionaria({
                                ...concesionaria,
                                tyc_Con: event.target.value,
                              });
                            }}
                            required={true}
                            id={"tyc_Con"}
                          />

                        </div>
                      </div>

                      <div className="col-12 col-sm-4 h-ful p-4">
                        <TextArea
                          inputLabel="Cambios encontrados"
                          id="mensaje"
                          inputField={mensaje}
                          onFocus
                          readOnly
                          disabled
                          rows={10}
                          extraStyle="change_color_negro"
                        />
                      </div>

                    </div>
                  </>
                ) : (
                  <>
                    <div className="row  p-0 mx-0 mt-4">
                      <div className="col-12 col-sm-6 ps-0 pr-0 pr-sm-2 mt-2 mt-sm-0">
                        <InputText
                          inputLabel={"Nombre"}
                          id={"razon"}
                          inputField={concesionaria.razon}
                          changingInput={(event) => {
                            setConcesionaria({
                              ...concesionaria,
                              razon: event.target.value,
                            });
                          }}
                          required={true}
                        />

                      </div>
                      <div className="col-12 col-sm-6 px-0 pl-0 pl-sm-2 mt-2 mt-sm-0">
                        <StaticTextField 
                          value={concesionaria.entidad_Con}
                          inputLabel={"Estado"}
                        />

                      </div>
                    </div>

                    <div className="row  p-0 mx-0 mt-2">
                      <div className="col-12 col-sm-6 ps-0 pr-0 pr-sm-2 mt-2 mt-sm-0">
                        <InputText
                          inputLabel={"Nombre comercial"}
                          id={"nomComercial"}
                          inputField={concesionaria.nomComercial}
                          changingInput={(event) => {
                            setConcesionaria({
                              ...concesionaria,
                              nomComercial: event.target.value,
                            });
                          }}
                          required={true}
                        />

                      </div>
                      
                      <div className="col-12 col-sm-6 px-0 pl-0 pl-sm-2 mt-2 mt-sm-0">
                        <StaticTextField 
                          value={concesionaria.ciudad_Con}
                          inputLabel={"Ciudad"}
                        />
                      </div>
                    </div>

                    <div className="row  p-0 mx-0 mt-2">
                      <div className="col-6 col-sm-3 ps-0 pr-0 pr-sm-2">
                        <InputText
                          inputLabel={"Número concesionaria"}
                          inputField={concesionaria.numCON}
                          changingInput={(event) => onChangeNumConcensinaria(event)}
                          validationFunction= {(event) => event.target.value.length < 5}
                          required={true}
                          disabled={concesionaria.idCON}
                          id={"numCON"}
                        />
                      </div>
                      <div className="col-6 col-sm-3 ps-0 pl-2 pr-0 pr-sm-2">
                        <DropdownSearch
                          menu={marcas.map((marca) => (
                            {
                              nombre: marca,
                            }
                          ))}
                          title={"Marca"}
                          defaultValue={marcaCatTable(concesionaria.id_Marc)}
                          handleOptionSelected={(e) => {
                            const id_Marc = idMarcaCat(e.props.value);
                            setConcesionaria({
                              ...concesionaria,
                              id_Marc: parseInt(id_Marc),
                            });
                          }}
                          fieldID={'nombre'}
                          fieldToShow={'nombre'}
                        />
                      </div>
                      <div className="col-12 col-sm-6 px-0 pl-0 pl-sm-2 mt-4 mt-sm-0">
                        <InputText
                          inputLabel={"Código postal"}
                          inputField={concesionaria.cp}
                          changingInput={(event) => onChangeCP(event)}
                          validationFunction={(event) => event.target.value.length < 6}
                          required={true}
                          id={"cp"}
                        />

                      </div>
                    </div>

                    <div className="row  p-0 mx-0 mt-2">
                      <div className="col-12 col-sm-6 ps-0 pr-0 pr-sm-2">
                        <DropdownSearch
                          menu={estadoCat.map((ele, index) => {
                            return {
                              nombre: ele
                            }
                          })}
                          title={"Estado"}
                          defaultValue={concesionaria.estadoActivo ? "Activo" : "Inactivo"}
                          handleOptionSelected={(e) => {
                            let status = e.props.value === "Activo" ? 1 : 0;
                            setConcesionaria({
                              ...concesionaria,
                              estadoActivo: status,
                            });
                          }}
                          fieldID={'nombre'}
                          fieldToShow={'nombre'}
                        />
                      </div>
                      <div className="col-12 col-sm-6 px-0 pl-0 pl-sm-2 mt-4 mt-sm-0">
                        <InputText
                          inputLabel={"Ubicación"}
                          inputField={concesionaria.ubicacionGeof}
                          changingInput={(event) => {
                            setConcesionaria({
                              ...concesionaria,
                              ubicacionGeof: event.target.value,
                            });
                          }}
                          required={true}
                          id={"ubicacionGeof"}
                        />

                      </div>
                    </div>

                    <div className="row p-0 mx-0 mt-2">
                      <div className="col-6 col-sm-3 ps-0 pr-0 pr-sm-2">
                        <InputText
                          inputLabel={"Correo"}
                          inputField={concesionaria.correoContacto}
                          changingInput={(event) => {
                            setConcesionaria({
                              ...concesionaria,
                              correoContacto: event.target.value,
                            });
                          }}
                          required={true}
                          type="email"
                          id={"correoContacto"}
                        />

                      </div>

                      <div className="col-6 col-sm-3 ps-0 pl-2 pr-0 pr-sm-2">
                        <InputText
                          inputLabel={"Teléfono"}
                          inputField={concesionaria.tel_contacto}
                          changingInput={(event) => onChangeTelefono(event)}
                          validationFunction={(event) => {
                            if (event.target.value.length < 11) {
                              let value = event.target.value;
                              const pattern = new RegExp("^[0-9]*$");
                              let isValidKey = pattern.test(value);
                              return isValidKey;
                            }
                            return false;
                          }}
                          required={true}
                          id={"tel_contacto"}
                        />
                      </div>
                      <div className="col-12 col-sm-6 px-0 pl-0 pl-sm-2 mt-2 mt-sm-0">
                        <InputText
                          inputLabel={"Términos y condiciones"}
                          inputField={concesionaria.tyc_Con}
                          changingInput={(event) => {
                            setConcesionaria({
                              ...concesionaria,
                              tyc_Con: event.target.value,
                            });
                          }}
                          required={true}
                          id={"tyc_Con"}
                        />

                      </div>
                    </div>

                    <div className="row p-0 mx-0 mt-2">
                      <div className="col-12 col-sm-6 ps-0 pr-0 pr-sm-2">
                        <InputText
                          inputLabel={"Dirección"}
                          inputField={concesionaria.direct_Con}
                          changingInput={(event) => {
                            setConcesionaria({
                              ...concesionaria,
                              direct_Con: event.target.value,
                            });
                          }}
                          required={true}
                          id={"direct_Con"}
                        />

                      </div>
                      <div className="col-12 col-sm-6 px-0 pl-0 pl-sm-2 mt-2 mt-sm-0">
                        <InputText
                          inputLabel={"Correo DWA"}
                          inputField={concesionaria.dwa_Contacto}
                          changingInput={(event) => {
                            setConcesionaria({
                              ...concesionaria,
                              dwa_Contacto: event.target.value,
                            });
                          }}
                          id={"dwa_Contacto"}
                          type="email"
                        />

                      </div>
                    </div>
                  </>
                )}
                
              </div>

              <div className="modal-footer footer_modal_vw d-flex justify-content-center justify-content-lg-end gap-2 gap-sm-3 gap-lg-2 px-0 mx-3 mx-lg-5 mb-2 mb-lg-0">
                <button
                  type="button"
                  className="button_vw button_vw--secondary order-2 order-sm-1"
                  data-bs-dismiss="modal"
                  onClick={() => {
                    if (editar === 3 && !filasRevisadas.includes(concesionaria.numCON)) {
                      setRow("");
                      setMostrarModal(true);
                      setMensajeArchivar("¿Seguro que quieres cancelar esta alta?");
                    } else {
                      setModal(false);
                    }
                  }}
                >
                  Cancelar
                </button>
                {(editar!==3 && concesionaria.cambios) && edita ? (
                  <button
                    type="button"
                    className="button_vw button_vw--secondary order-2 order-sm-1"
                    data-bs-dismiss="modal"
                    onClick={() => {
                      setModal(false);
                      if (concesionaria.cambios && !filasRevisadas.includes(concesionaria.numCON)) {
                        setFilasRevisadas((prev) => [...prev, concesionaria.numCON]); // Agregar a filas revisadas
                        setNumModificaciones((prev) => prev - 1); // Reducir el conteo
                        updateCheckedStatus(concesionaria.numCON, true); // Marcar como revisada
                        
                        if(concesionaria.cambios.cambio === 1){
                          setFilasModificadas((prev) =>
                            prev.filter((fila) => fila.numCON !== concesionaria.numCON)
                          );
                        }
                      }
                    }}
                  >
                    No cambiar
                  </button>
                ):""}

                <button
                  type="submit"
                  className="button_vw button_vw--primary order-1 order-sm-2"
                  data-bs-dismiss="modal"
                  data-track-click="btn-guardar-dealer"
                >
                  Guardar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>)
    );
  };

  function localDateTimeToUTC(date) {
    const fechaLocal = new Date(date);

    // Fecha UTC en formato compatible con MYSQL: YYYY-MM-DD HH:MM:SS
    const fechaUTC = fechaLocal.toISOString().slice(0, 19).replace("T", " ");

    return fechaUTC;
  }
  const onChangeGrid = (value) => {
    setShowGrid(value);
    setSelectGrid([])
    toggleAllRowsSelected(false);
  };
  const selects = (checkObj, tipo) => {
    if (tipo === "push") {
      setSelectGrid([...selectGrid, checkObj]);
    } else if (tipo === "pop") {
      let idCON = checkObj.idCON;
      setSelectGrid((l) =>
        l.filter((item) => item.idCON !== idCON)
      );
    }
  };

  const iconMarca = (idMarca) => {
    switch (idMarca) {
      case 1:
        return (
          <>
            <img src={icono_vw} alt="icono" className="pe-3 "></img>
          </>
        );
      case 2:
        return (
          <>
            <img src={icono_vw} alt="icono" className="pe-3 "></img>
          </>
        );
      case 3:
        return (
          <>
            <img src={icono_seat} alt="icono" className="pe-3"></img>
          </>
        );
      case 4:
        return (
          <>
            <img src={icono_audi} alt="icono" className="pe-3 "></img>
          </>
        );
      case 5:
        return (
          <>
            <img src={icono_cupra} alt="icono" className="pe-3"></img>
          </>
        );
      default:
        return (
          <>
            <img src={icono_vw} alt="icono" className="pe-3 "></img>
          </>
        );
    }
  };

  const gridConcesionarias = (page) => {
    const selectCheck = (e, index) => {
      let y = document.getElementById(e.target.id);
      let concesionaria = page[index].original;
      if (y.checked) {
        selects(concesionaria, "push");
      } else {
        selects(concesionaria, "pop");
      }
    };

    return (
      <div className="grid__view row">
        {page.map((aplicacion, index) => {
          return (
            <div className="col-3 mb-3" key={index}>
              <div className="card_grid">
                <div className="d-flex">
                  <div className="container_id">
                    {aplicacion.original.idCON}
                  </div>
                  <div key={"select-" + index} className="ms-auto">
                    <input
                      key={"select-" + index}
                      type="checkbox"
                      className="checkbox-round mx-1"
                      id={"select-" + index}
                      value={aplicacion.original.idCON}
                      onChange={(e) => selectCheck(e, index)}
                    />
                  </div>
                </div>

                <div className="d-flex align-items-start flex-column mx-4 mt-2 size-card">
                  <div
                    className="onclick "
                    onClick={() => {
                      setSelectedDealer({ row: aplicacion });
                      editConcesionaria(aplicacion.original)
                    }}
                    data-track-click="btn-editar-dealer"
                  >
                    <div className="w-100 d-flex flex-row align-items-center">
                      <div className="">{iconMarca(aplicacion.original.id_Marc)}</div>
                      <div className="title_card_concensionaria">
                        {aplicacion.original.razon.length > 35 ? `${aplicacion.original.razon.substring(0, 32)}…` : aplicacion.original.razon}
                      </div>
                    </div>

                    <div className="url_card mt-2">Fecha de registro:</div>

                    <div className="url_description mb-auto">
                      {localDateTimeToUTC(aplicacion.original.regFecha_Con)}
                    </div>
                  </div>
                  <div>
                    <img src={activo_icono} alt="activo"></img>
                    <span className="url_description mx-2">
                      {aplicacion.original.numCON}
                    </span>

                    <div className={` tooltip_vw`}>
                      <img src={menu_opc} alt="menu"></img>
                      <div className="tooltiptext p-2 ">
                        <button
                          className="button_icon-vw"
                          type="button"
                          onClick={() => {
                            setSelectedDealer({ row: aplicacion })
                            editConcesionaria(aplicacion.original)
                          }}
                          data-track-click="btn-editar-dealer"
                        >
                          <div className="aling-icon">
                            {" "}
                            <img
                              src={editar_icon}
                              alt="editar"
                              className="px-1"
                            ></img>{" "}
                            Editar
                          </div>
                        </button>
                        <button
                          className="button_icon-vw"
                          type="button"
                          onClick={() => handleArchivar({ row: aplicacion })}
                        >
                          <div className="aling-icon-archivar">
                            {" "}
                            <img
                              src={archivar_blanco}
                              alt="archivar"
                              className="px-2"
                            ></img>{" "}
                            Archivar
                          </div>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  const NavigationControl = () => {
    return (
      <div className="btn-group btn-group-controls" role="group" aria-label="First group">
        <button
          onClick={() => gotoPage(0)}
          disabled={!canPreviousPage}
          className={
            "btn btn-secondary btn__secondary-- btn_pagination"
          }
        >
          <img src={double_before} alt="first" />
        </button>
        {" "}
        <button
          onClick={() => previousPage()}
          disabled={!canPreviousPage}
          className={
            "btn btn-secondary btn__secondary-- btn_pagination"
          }
        >
          <img src={before} alt="before" />
        </button>
        {" "}
        <div className="num_pagination py-3">
          {pageIndex + 1} de {pageOptions.length}
        </div>
        <button
          onClick={() => nextPage()}
          disabled={!canNextPage}
          className={
            "btn btn-secondary btn__secondary-- btn_pagination"
          }
        >
          <img src={after} alt="after" />
        </button>
        {" "}
        <button
          onClick={() => gotoPage(pageCount - 1)}
          disabled={!canNextPage}
          className={
            "btn btn-secondary btn__secondary-- btn_pagination"
          }
        >
          <img src={double_after} alt="last" />
        </button>
        {" "}
      </div>
    );
  }

  function updateCheckedStatus(numCON, checked) {
    setFilasModificadas((prev) =>
      prev.map((fila) =>
        fila.numCON === numCON
          ? {
              ...fila,
              ...fila.cambios = {
                ...fila.cambios,
                checked: checked
              }
            }
          : fila
      )
    );
  }
  
  return cargando ? (
    <Loading />
  ) : (
    <>
      <div className="content main-content-container">
        <div className="main-content-actions row m-0 py-2" >
          <div className={`col-7 col-sm-6 col-lg-3 wrapper m-0 p-0 ${isPaginationDisabled ? "opacity-50":"opacity-100"}`}>
            <input
              className="input_vw"
              name="searchInput"
              value={searchInput || ""}
              onChange={(e) => {
                searchText(e);
              }}
              placeholder="Busca por el número de concesionaria"
              disabled={isPaginationDisabled}
            />
            <span className="pt-2 ps-1">
              <img src={SEARCH} alt="buscar" className="icono-menu me-3" />
            </span>
          </div>

          <div className="d-flex col-2 col-sm-1 col-lg-3 gap-2">
            <button
              type="button"
              onClick={()=>addConcesionaria(null)}
              className={"m-0 button_vw button_vw--primary button_new_item " + (!!(selectedFlatRows.length > 0 || selectGrid.length > 0) ? "is_not_enabled" : "enabled")}
              disabled={!!(selectedFlatRows.length > 0 || selectGrid.length > 0)}
              data-track-click="btn-nuevo-dealer"
            >
              <div className={"add-icon"}></div>
              <span className={"ml-2"}>Nuevo</span>
            </button>

            <button
              type="button"
              onClick={cargarArchivo} //Cargar archivo xsml
              className={`m-0 button_vw button_vw--secondary button_upload_item ${!isPaginationDisabled ? "" : "enabled opacity-50"}`}
              disabled={!!(selectedFlatRows.length > 0 || selectGrid.length > 0 || isPaginationDisabled)}
              data-track-click="btn-subir-doc-dealer"
            >
              <div className={"upload-icon"}></div>
              <span className={"ml-2"}>Subir doc.</span>
            </button>

            {selectedFlatRows.length > 0 || selectGrid.length > 0 ? (
              <button
                type="button"
                className={"button_vw m-0 button_vw--archivo button_store_item"}
                onClick={handleArchivar}
              >
                <div className={"archivar-icon"}></div>
                <span className={"ml-2"}>Archivar</span>
              </button>
            ) : (
              ""
            )}
          </div>
          {/* Input oculto para carga de archivos */}
          <input
            type="file"
            ref={fileInputRef}
            style={{ display: 'none' }}
            accept=".xlsm"
            onChange={handleFileChange}
          />

          <div className="col-3 col-md-5 col-lg-6 p-0">
            <div className="d-flex justify-content-end align-items-center ">
              <div className="">
                <button
                  className={`button_icon-vw kit_icon ${ numModificaciones === 0 ? "opacity-100" : "opacity-25" }`}
                  type="button"
                  onClick={() => window.location.reload()}
                  disabled={numModificaciones === 0 ? false : true}
                >
                  <span
                    className="icon-refresh"
                  >
                    {" "}
                  </span>
                </button>
              </div>
              <div className={`view_select_all ${showGrid ? 'icon_grid_active' : ''} ms-auto align-self-center`}>
                <input
                  type="checkbox"
                  className="checkbox-round mx-1"
                  id={"1"}
                  value={0}
                  onChange={() => {
                  }}
                  disabled={numModificaciones === 0 ? false : true}
                />
              </div>
              <div className="view__options">
                <button
                  className="button_icon-vw kit_icon"
                  type="button"
                  onClick={() => onChangeGrid(true)}
                  disabled={numModificaciones === 0  ? false : true}
                >
                  <span
                    className={`${showGrid ? "icon-grid-active" : "icon-grid"} ${filasModificadas.length ? "opacity-25" : "opacity-100"}`}
                  >
                    {" "}
                  </span>
                </button>
                <button
                  className="button_icon-vw kit_icon"
                  type="button"
                  onClick={() => onChangeGrid(false)}
                >
                  <span
                    className={`${!showGrid ? "icon-table-active" : "icon-table"
                      } ${filasModificadas.length ? "opacity-25" : "opacity-100"}`}
                  >
                    {" "}
                  </span>
                </button>
              </div>
              <div className="">
                <DropDown
                  menu={limitMostrar}
                  title={dropdownLimit}
                  inputField={limit}
                  handleOptionSelected={(e) => {
                    setDropdownLimit(e);
                    const limitInt = optionLimit(e);
                    setLimit(limitInt);
                    setPageSize(Number(limitInt));
                  }}
                  disabled={isPaginationDisabled}
                />
              </div>
              <NavigationControl />
            </div>
          </div>
        </div>
      </div>
      <div className="d-md-none">
        <Cards
          page={page}
          editar={(seleccionada) => {
            setSelectedDealer(seleccionada);
            editConcesionaria(seleccionada);
          }}
          handleArchivar={handleArchivar}
          selects={selects}
          NavigationControl={NavigationControl}
        />
      </div>
      {showGrid ? (
        gridConcesionarias(page)
      ) : (
        <div 
          className=""
          style={{
            overflowY: 'hidden'
          }}
        >
          <table
            {...getTableProps()}
            className="table d-md-block table-striped table-responsive tabla_contenido_vw"
            id="table-canales"
          >
            <thead className="thead-dark">
              {headerGroups.map((headerGroup) => (
                <tr
                  {...headerGroup.getHeaderGroupProps()}
                  className="thead__titulo"
                >
                  {headerGroup.headers.map((column) => (
                    <th {...column.getHeaderProps()}>
                      {column.render("Header")}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()} className="tbody-table">
              {filasCambios.map((fila,index) => (
                <tr 
                  onClick={() => {
                    setSelectedDealer(fila);
                    if(fila.cambios.cambio === 3){
                      addConcesionaria(fila);
                    } else {
                      editConcesionaria(fila);
                    }
                  }}
                  key={`${fila.numCON}`}
                  className="table-tr-check"
                  data-track-click="btn-editar-dealer"
                >
                {visibleColumns.map((column,cellId) => {
                  const color = obtenerClaseFila(fila.cambios.cambio);
                  const value = fila[column.id];

                  if (column.id === "selection") {
                    return (
                      <td 
                        key={`selection-${fila.numCON}`}
                        id={`selection-${fila.numCON}`}
                      >
                        {fila.cambios.checked === true ? <img src={success_icono} alt="Success icon" />:<></>}
                      </td>
                    );
                  } else {
                    switch(column.Header){
                      case "Activo":
                        return (
                          <td 
                            key={`activo-${fila.numCON}-${index}`}
                            className=""
                          >
                            <img src={value === 1 ? activo_icono : inactivo_icono} alt="activo/inactivo" />
                          </td>
                        );
                      case "Marca":
                        return (
                          <td 
                            key={`marca-${fila.numCON}-${index}`}
                            className={`contenido_boolean ${color} `}
                          >
                            {marcaCatTable(value)}
                          </td>
                        );
                      case "Correo":
                        return (
                          <td 
                            key={`correo-${fila.numCON}-${index}`}
                            className="contenido_boolean"
                          >
                            <div className={`d-flex justify-content-between ${color} `}>
                              {value}
                              {/* sin menú en nuevas filas */}
                            </div>
                          </td>
                        );

                      case "Fecha de registro":
                        return (
                          <td
                            key={`fecha-${fila.numCON}-${index}`}
                            className={`contenido_boolean ${color} `}
                          >
                            <div className={`d-flex justify-content-between `}>
                              {value == null ? "" : localDateTimeToUTC(value)}
                            </div>
                          </td>
                        );
                      
                      default:
                        return (
                          <td
                            key={`${fila.numCON}-${index}${cellId}`}
                            className={`contenido_boolean ${color} `}
                          >
                            {value ?? <img src={null_icono} alt="sinsoporte" />}
                          </td>
                        );
                    }
                  }
    
                })}

                </tr>

              ))}
              
              {filas.map((row) => {
                prepareRow(row);
                
                return (
                  <tr
                    {...row.getRowProps()}
                    className={`table-tr-check`}
                    key={`${row.original.numCON}`}
                    id={row.original.numCON}
                  >
                      {row.cells.map((cell, cellId) => {
                        
                        if (cell.column.id !== "selection" && (cell.value === undefined || cell.value === "")) {
                          return (
                            <td><img src={null_icono} alt="sinsoporte"></img></td>
                          );
                        }
                        if (cell.column.id === "selection") {
                          return (
                            <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                          );
                        }
                        if (cell.column.Header === "Activo") {
                          if (cell.value === 1) {
                            return (
                              <td
                                className="contenido_boolean"
                                {...cell.getCellProps()}
                                onClick={() => {
                                  setSelectedDealer(cell.row.original);
                                  editConcesionaria(cell.row.original);
                                }}
                                data-track-click="btn-editar-dealer"
                              >
                                <img src={activo_icono} alt="activo"></img>
                              </td>
                            );
                          } else
                            return (
                              <td
                                className="contenido_boolean"
                                {...cell.getCellProps()}
                                onClick={() => {
                                  setSelectedDealer(cell.row.original);
                                  editConcesionaria(cell.row.original);
                                }}
                                data-track-click="btn-editar-dealer"
                              >
                                <img src={inactivo_icono} alt="inactivo"></img>
                              </td>
                            );
                        }
                        if (cell.column.Header === "Fecha de registro") {
                          return (
                            <td
                              className="contenido_boolean"
                              {...cell.getCellProps()}
                            >
                              <div className={`d-flex justify-content-between `}>
                                {localDateTimeToUTC(cell.value)}
                                
                              </div>
                            </td>
                          );
                        }
                        if(cell.column.Header === "Ubicación"){
                          return (
                            <td
                              className=""
                              {...cell.getCellProps()}
                            >
                              <div className={`d-flex justify-content-between `}>
                                {cell.value}
                                <div className={` tooltip_vw`}>
                                  <img src={menu_opc} alt="menu"></img>
                                  <div className="tooltiptext p-2">
                                    <button
                                      className="button_icon-vw"
                                      type="button"
                                      onClick={() => {
                                        setSelectedDealer(cell.row.original);
                                        editConcesionaria(cell.row.original);
                                      }}
                                      data-track-click="btn-editar-dealer"
                                    >
                                      <div className="aling-icon">
                                        {" "}
                                        <img
                                          src={editar_icon}
                                          alt="editar"
                                          className="px-1"
                                        ></img>{" "}
                                        Editar
                                      </div>
                                    </button>
                                    <button
                                      className="button_icon-vw"
                                      type="button"
                                      onClick={() => handleArchivar(cell)}
                                    >
                                      <div className="aling-icon-archivar">
                                        {" "}
                                        <img
                                          src={archivar_blanco}
                                          alt="archivar"
                                          className="px-2"
                                        ></img>{" "}
                                        Archivar
                                      </div>
                                    </button>
                                  </div>
                                </div>
                                
                              </div>
                            </td>
                          );
                        }
                        return (
                          <td
                            {...cell.getCellProps()}
                            onClick={() => {
                              setSelectedDealer(cell);
                              editConcesionaria(cell.row.original);
                            }}
                            data-track-click="btn-editar-editar-dealer"
                          >
                            {cell.render("Cell")}
                          </td>
                        );
                      })}
                    </tr>
                  );
              })}
            </tbody>
          </table>
        </div>
      )}

      {buildPopUp()}
      {buildPopUpRegistro()}
    </>
  );
}

function Tabla(props) {
  const columns = React.useMemo(
    () => [
      {
        Header: "ID",
        accessor: "idCON",
      },
      {
        Header: "Nombre",
        accessor: "razon",
      },
      {
        Header: "Número",
        accessor: "numCON",
      },
      {
        Header: "Marca",
        accessor: "id_Marc",
        Cell: (props) => <div> {marcaCatTable(props.value)} </div>,
      },
      {
        Header: "Activo",
        accessor: "estadoActivo",
      },
      {
        Header: "Fecha de registro",
        accessor: "regFecha_Con",
      },
      {
        Header: "Correo",
        accessor: "correoContacto",
      },
      {
        Header: "Télefono",
        accessor: "tel_contacto"
      },
      {
        Header: "Dirección",
        accessor: "direct_Con"
      },
      {
        Header: "Ciudad",
        accessor: "ciudad_Con"
      },
      {
        Header: "Entidad",
        accessor: "entidad_Con"
      },
      {
        Header: "CP",
        accessor: "cp"
      },
      {
        Header: "Ubicación",
        accessor: "ubicacionGeof"
      }
    ],
    []
  );

  return (
    <Table
      columns={columns}
      data={props.data}
      servicio={props.servicio}
      handleChange={props.handleChange}
    />
  );
}

function assignEmptyStringToNullProperties(obj) {
  for (let key in obj) {
    if (obj[key] === null || obj[key] === undefined) {
      obj[key] = ""; // Assign empty string to null properties
    }
  }
}

function validateEmail(email) {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  return emailRegex.test(email);
}

const marcaCatTable = (idMarca) => {
  switch (idMarca) {
    case 1:
      return "VW";
    case 2:
      return "VW Comercial";
    case 3:
      return "Seat";
    case 4:
      return "Audi";
    case 5:
      return "Cupra";
    default:
      return "Marca";
  }
};

const idMarcaCat = (text) => {
  switch (text) {
    case "VW":
      return 1;
    case "VW Comercial":
      return 2;
    case "Seat":
      return 3;
    case "Audi":
      return 4;
    case "Cupra":
      return 5;
    default:
      return 1;
  }
};

export default Tabla;
